import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';

@Injectable()
export class AuthService {
  public loggedIn = true;

  constructor(private router: Router) {
  }

  public async logIn(login: string, password: string) {
    this.loggedIn = true;
    await this.router.navigate(['/']);
  }

  public async logOut() {
    this.loggedIn = false;
    await this.router.navigate(['/login-form']);
  }

  get isLoggedIn() {
    return this.loggedIn;
  }
}

@Injectable()
export class AuthGuardService  {
  constructor(private router: Router, private authService: AuthService) {
  }

  public async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    const isLoggedIn = this.authService.isLoggedIn;
    const isLoginForm = route.routeConfig !== undefined && route.routeConfig !== null && route.routeConfig.path === 'login-form';

    if (isLoggedIn && isLoginForm) {
      await this.router.navigate(['/']);
      return false;
    }

    if (!isLoggedIn && !isLoginForm) {
      await this.router.navigate(['/login-form']);
    }

    return isLoggedIn || isLoginForm;
  }
}
